import React, { useState, useMemo, ReactNode, useEffect } from 'react'
import { DownloadsProviderContext } from './context'
import { DocumentLanguageFilterType } from '../models/downloads.model'
import { getCurrentLanguage } from 'src/Libs/languages/functions/default'

interface DownloadsProviderProps {
  children: ReactNode
}

export const DownloadsProvider: React.FC<DownloadsProviderProps> = ({ children }) => {
  const defaultLang = getCurrentLanguage() as DocumentLanguageFilterType
  const [languageFilter, setLanguageFilter] = useState<DocumentLanguageFilterType>(defaultLang)

  useEffect(() => {
    setLanguageFilter(defaultLang)
  }, [defaultLang])

  const contextValue = useMemo(
    () => ({
      languageFilter,
      setLanguageFilter,
    }),
    [languageFilter]
  )

  return <DownloadsProviderContext.Provider value={contextValue}>{children}</DownloadsProviderContext.Provider>
}
